export default "__VITE_ASSET__Dv$YZiov__"